import { I18n } from 'react-redux-i18n';
import { IColumnData } from '../models/table/columnData';

export const EVENT_ORGANIZER_API_PATH = 'EventOrganizer';

const ViewListPath = 'eventOrganizers.page.view.list';
const InputPath = 'eventOrganizers.page.input';

export const eventOrganizerHeaders = {
  NAME: `${ViewListPath}.name`,
  PRIORITY: `${ViewListPath}.priority`,
};

export const eventOrganizerColumns = {
  NAME: 'name',
  PRIORITY: 'priority',
};

export const eventOrganizerDefaultOrderBy = {
  path: 'name',
  order: 'asc' as const,
};

export const eventOrganizersAvailableFiltersKeys: string[] = [
  eventOrganizerColumns.PRIORITY,
];

const formatPriorityLabel = (value: string) => {
  if (!value) return '';
  const key = `${InputPath}.priority.options.${value}.label`;
  const translated = I18n.t(key);
  return translated === key ? value : translated;
};

export const eventOrganizerColumnData: IColumnData[] = [
  {
    header: eventOrganizerHeaders.NAME,
    path: eventOrganizerColumns.NAME,
    defaultVisible: true,
  },
  {
    header: eventOrganizerHeaders.PRIORITY,
    path: eventOrganizerColumns.PRIORITY,
    defaultVisible: true,
    customFormatter: formatPriorityLabel,
  },
];
